import "./Hero.css"
function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <div>
            <h1>NIEC</h1>
            <h1>GLOBAL</h1>
            <div className="strip">
              <h1 className="hero-highlight">AMBASSADOR</h1>
            </div>
          </div>
          <div className="col-custom pt-4">
            <p>
              NIEC Global Ambassador adalah orang atau lembaga yang memiliki 
              keinginan untuk membantu, keluarga, teman, siswa atau kenalan 
              untuk bisa kuliah di luar negri
            </p>
          </div>
          <div className="d-flex justify-content-center">
            <a href="#form" className="btn-custom2">Daftar Sekarang</a>
          </div>
        </div>
      </div>
      <div className="hero-banner"></div>      
      <div className="hero-talent"></div>      
    </section>
  );
}

export default Hero;